<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <router-link
              v-if="this.frmPedido.tipo == 'C'"
              v-bind:to="{
                name: 'meus-pedidos',
                params: { tipo: this.frmPedido.tipo },
              }"
              >Pedido de Venda Normal</router-link
            >

            <router-link
              v-else-if="this.frmPedido.tipo == 'V'"
              v-bind:to="{
                name: 'meus-pedidos',
                params: { tipo: this.frmPedido.tipo },
              }"
              >Pedido de Venda Direta</router-link
            >

            <router-link
              v-else-if="this.frmPedido.tipo == 'A'"
              v-bind:to="{
                name: 'meus-pedidos',
                params: { tipo: this.frmPedido.tipo },
              }"
              >Pedido Ativo Imobilizado</router-link
            >
          </li>
          <li class="item-link">DETALHE DO PEDIDO</li>
        </ul>
      </div>
      <div class="main-content-area">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="box-title first">DETALHE DO PEDIDO</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <form @submit.prevent="search" action="#" method="get" name="frm-billing">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Ordem de Compra</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <p>{{ this.frmPedido.ordemCompra }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Data Pedido</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <p>{{ this.frmPedido.dataPedido }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Nota Fiscal</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <p>{{ this.frmPedido.notaFiscal }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Data Faturamento</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <p>{{ this.frmPedido.dataFaturamento }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Cliente</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <p>{{ this.frmPedido.cliente }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Cidade</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <p>{{ this.frmPedido.cidade }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Transportadora</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <p>{{ this.frmPedido.transportadora }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Resp. Retirada</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <p>{{ this.frmPedido.respRetirada }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Situação</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <p>{{ this.frmPedido.situacao }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Tipo de Venda</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <p>{{ this.frmPedido.tipoVenda }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Digitador</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <p>{{ this.frmPedido.digitador }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Vendedor</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <p>{{ this.frmPedido.vendedor }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Comprador</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <p>{{ this.frmPedido.comprador }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="solAgora.idProjeto">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Financ. Sol Agora</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <button
                        aria-label="Recarregar solAgora"
                        id="reloadSantander"
                        @click="getDadosSolAgora()"
                        style="border-radius: 7px; background: #021745; margin: 5px"
                        class="pull-right btn btn-primary"
                      >
                        <i :class="solAgora.classBtn" aria-hidden="true"></i>
                      </button>

                      <div style="margin-top: -1px" :class="'alert alert-' + solAgora.classAlert">
                        <h4>
                          <b>{{ solAgora.status }}</b>
                        </h4>
                        <br />
                        Última atualização em {{ solAgora.dataAtualizacao | datahorabr }}
                        <p style="height: 10px"></p>
                        <p><b>Número do Projeto:</b> {{ solAgora.externalId }}</p>
                        <p>
                          <b>Parcela:</b> {{ solAgora.numeroParcelas }} x
                          {{ formatCurrency(solAgora.valorParcelas) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="santander.idProposta > 0">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <p>
                        <b>Santander</b>
                      </p>
                    </div>
                    <div class="col-md-8">
                      <button
                        aria-label="Recarregar Santander"
                        id="reloadSantander"
                        @click="getDadosSantander(0)"
                        style="border-radius: 7px; background: #021745"
                        class="pull-right btn btn-primary"
                      >
                        <i :class="santander.classBtn" aria-hidden="true"></i>
                      </button>
                      <div style="margin-top: -1px" :class="'alert alert-' + santander.classAlert">
                        <b>{{ santander.status }}</b> <br />
                        Última atualização em {{ santander.dataAtualizacao }}
                        <p style="height: 10px"></p>
                        <p><b>Número da Proposta:</b> {{ santander.externalId }}</p>
                        <p>
                          <b>Parcela:</b> {{ santander.numeroParcelas }} x
                          {{ formatCurrency(santander.valorParcelas) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="frmPedido.situacao == 'PEDIDO FATURADO' && trackingrodonaves.CTeNumber !== ''">
                <div class="row" v-if="frmPedido.situacao == 'PEDIDO FATURADO' && trackingrodonaves.CTeNumber !== ''">
                  <div class="col-md-12">
                    <h3 class="box-title">RASTREAMENTO DE TRANSPORTES RODONAVES</h3>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="table-responsive">
                    <table class="table table-striped table-product">
                      <tbody>
                        <tr>
                          <td width="390">Conhecimento</td>
                          <td>
                            <p>{{ this.trackingrodonaves.CTeNumber }}</p>
                          </td>
                        </tr>
                        <tr v-for="track in this.trackingrodonaves.historico">
                          <td>{{ track.Description }}</td>
                          <td>{{ track.Date }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row" v-if="frmPedido.situacao == 'PEDIDO FATURADO' && trackingbraspress.historico.length > 0">
                <div class="row">
                  <div class="col-md-12">
                    <h3 class="box-title">RASTREAMENTO DE TRANSPORTES BRASPRESS</h3>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="table-responsive">
                    <table class="table table-striped table-product">
                      <tbody>
                        <tr v-for="track in this.trackingbraspress.historico">
                          <td>Prev.Entrega: {{ track.previsaoEntrega }}</td>
                          <td>Data.Entrega: {{ track.dataEntrega }}</td>
                          <td>Status: {{ track.status }}</td>
                          <td>Dt.Ocorrência: {{ track.dataOcorrencia }}</td>
                          <td>Últ.Ocorrência: {{ track.ultimaOcorrencia }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row" v-if="frmPedido.situacao == 'PEDIDO FATURADO' && trackingrodonaves.CTeNumber !== ''">
                <div class="col-xs-12">
                  <div class="table-responsive">
                    <table class="table table-striped table-product">
                      <tbody>
                        <tr>
                          <td width="390">Conhecimento</td>
                          <td>
                            <p>{{ this.trackingrodonaves.CTeNumber }}</p>
                          </td>
                        </tr>
                        <tr v-for="track in this.trackingrodonaves.historico">
                          <td>{{ track.Description }}</td>
                          <td>{{ track.Date }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="wrap-documents" v-if="documentosPrazo.length > 0 || documentosAVista.length > 0">
                <div class="row">
                  <div class="col-md-12">
                    <h3 class="box-title">DOCUMENTOS</h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <vue-good-table
                      v-if="documentosPrazo.length > 0"
                      :columns="columnsDocumentsPrazo"
                      :rows="documentosPrazo"
                      :pagination-options="{
                        enabled: false,
                      }"
                      styleClass="vgt-table"
                    >
                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'valor'">{{ formatCurrency(props.formattedRow[props.column.field]) }}</span>
                        <a
                          target="_blank"
                          v-else-if="props.column.field == 'documento' && props.row.quitado === '' && props.row.codBar !== ''"
                          :href="`${$SiteUrl}/Financeiro/duplicata/${props.row.notafiscal}/${props.row.serie}/${props.row.parcela}`"
                          >{{ props.formattedRow[props.column.field] }}</a
                        >
                        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                      </template>
                      <div slot="emptystate">Sem dados para exibição</div>
                    </vue-good-table>
                    <vue-good-table
                      v-if="documentosAVista.length > 0"
                      :columns="columnsDocumentsVista"
                      :rows="documentosAVista"
                      :pagination-options="{
                        enabled: false,
                      }"
                      styleClass="vgt-table"
                    >
                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'valor'">{{ formatCurrency(props.formattedRow[props.column.field]) }}</span>
                        <a
                          target="_blank"
                          v-else-if="
                            props.column.field == 'documento' && props.row.baixado === 0 && props.row.codBar !== '' && props.row.codBar !== null
                          "
                          :href="`${$SiteUrl}/Financeiro/duplicatavista/${props.row.documento}`"
                          >{{ props.formattedRow[props.column.field] }}</a
                        >
                        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                      </template>
                      <div slot="emptystate">Sem dados para exibição</div>
                    </vue-good-table>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <h3 class="box-title">PRODUTOS</h3>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-12">
                  <vue-good-table :columns="columnsProdutos" :rows="produtos" styleClass="vgt-table">
                    <div slot="emptystate">Sem dados para exibição</div>
                  </vue-good-table>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <h3 class="box-title">MATÉRIAS-PRIMAS</h3>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-12">
                  <vue-good-table
                    :columns="columnsProdutosNS"
                    :rows="produtosNS"
                    ref="groupedTable"
                    :group-options="{ enabled: true, collapsable: false }"
                    :pagination-options="{ enabled: false }"
                    styleClass="vgt-table"
                  >
                    <div slot="emptystate">Sem dados para exibição</div>
                  </vue-good-table>
                </div>
              </div>

              <!-- Venda Normal e Venda de Ativo -->
              <div class="row">
                <div class="col-md-12">
                  <h3 class="box-title vermelho" v-if="frmPedido.tipo == 'V'">BASE DE IMPOSTOS PARA CLIENTES</h3>
                  <h3 class="box-title vermelho" v-else>BASE DE IMPOSTOS</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <vue-good-table
                    :columns="columnsImpostos"
                    :rows="impostos"
                    :pagination-options="{
                      enabled: false,
                    }"
                    styleClass="vgt-table"
                  >
                    <template slot="table-row" slot-scope="props">
                      {{ props.formattedRow[props.column.field] }}
                    </template>
                    <div slot="emptystate">Sem dados para exibição</div>
                  </vue-good-table>
                </div>
              </div>

              <!-- Venda direta -->
              <div class="row" v-if="frmPedido.tipo == 'V'">
                <div class="col-md-12">
                  <h3 class="box-title">BASE DE IMPOSTOS PARA REVENDA</h3>
                </div>
              </div>
              <div class="row" v-if="frmPedido.tipo == 'V'">
                <div class="col-xs-12">
                  <vue-good-table
                    :columns="columnsImpostos"
                    :rows="impostosDireta"
                    :pagination-options="{
                      enabled: false,
                    }"
                    styleClass="vgt-table"
                  >
                    <template slot="table-row" slot-scope="props">
                      {{ props.formattedRow[props.column.field] }}
                    </template>
                    <div slot="emptystate">Sem dados para exibição</div>
                  </vue-good-table>
                </div>
              </div>

              <div class="row" v-if="frmPedido.situacao == 'PEDIDO FATURADO'">
                <div class="col-md-12">
                  <h3 class="box-title">INFORMAÇÕES DE VOLUME/PESO</h3>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-12">
                  <vue-good-table
                    v-if="frmPedido.situacao == 'PEDIDO FATURADO'"
                    :columns="columnsPesoVol"
                    :rows="pesovolume"
                    :pagination-options="{
                      enabled: false,
                    }"
                    styleClass="vgt-table"
                  >
                    <template slot="table-row" slot-scope="props">
                      {{ props.formattedRow[props.column.field] }}
                    </template>
                    <div slot="emptystate">Sem dados para exibição</div>
                  </vue-good-table>
                </div>
              </div>

              <!-- DANFE CLIENTE FINAL -->
              <div v-if="renderDanfe" class="row">
                <div class="col-md-12">
                  <h3 class="box-title">DANFE/XML da nota fiscal de venda (Revenda -> Cliente Final)</h3>
                </div>
              </div>
              <div v-if="mostraDownloadCliente" class="row">
                <div class="col-xs-12">
                  <vue-good-table
                    :columns="columnsDanfeCliente"
                    :rows="danfeCliente"
                    :pagination-options="{
                      enabled: false,
                    }"
                    styleClass="vgt-table"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'valorT'">{{ formatCurrency(props.formattedRow[props.column.field]) }}</span>
                      <span v-else-if="props.column.field == 'arq'"
                        ><a v-bind:href="frmPedido.arquivoCliente">{{ props.formattedRow[props.column.field] }}</a></span
                      >
                      <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                    </template>
                    <div slot="emptystate">Sem dados para exibição</div>
                  </vue-good-table>
                </div>
              </div>
              <div class="row" v-if="mostraUploadCliente">
                <div class="col-xs-12 col-md-6">
                  <div class="alert alert-warning">
                    <p>
                      <strong>Texto que deve constar nas informações complementares da nota fiscal a ser enviada:</strong>
                    </p>
                    <p>
                      <em
                        >A mercadoria será remetida pela empresa Descarbonize Soluções S/A, Av. Advogado Horácio Raccanello Filho n° 1836 - Maringá/PR
                        - CEP: 87.045-237 - CNPJ: 81.106.957/0001-19 e IE: 7010383638.
                      </em>
                    </p>
                  </div>
                </div>
                <div class="col-xs-12 col-md-6">
                  <div class="alert alert-warning">Envie apenas arquivos com as extenções .pdf ou .xml com no máximo <strong>5mb</strong></div>

                  <fieldset class="wrap-input">
                    <label for="docs-file-pessoal">Selecione um arquivo</label>
                    <div class="wrapper-file">
                      <label for="input-file" class="file-container">
                        <span class="file-name">Upload pendente:&nbsp;&nbsp;</span>
                        <span v-if="uploadPDF" class="file-name"
                          ><span class="vermelho"><strong>PDF</strong></span></span
                        ><i v-if="uploadPDF" class="fa fa-file-pdf-o vermelho" />
                        <span v-if="uploadXML" class="file-name"
                          ><span class="vermelho"><strong>XML</strong></span></span
                        ><i v-if="uploadXML" class="fa fa-file-code-o vermelho" />
                      </label>
                      <input type="file" id="input-file" v-on:change.prevent="SelecionaArquivo" accept=".pdf, .xml" />
                      <div
                        v-if="frmPedido.nomeArquivo"
                        id="arquivoPessoal"
                        style="
                          position: absolute;
                          top: 88px;
                          right: 0px;
                          left: 16px;
                          background: #0083ca;
                          padding: 12px;
                          width: 95%;
                          color: white;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        "
                      >
                        <span @click="removeClass" style="color: white" class="close">x</span>
                        <span>{{ frmPedido.nomeArquivo }}</span>
                      </div>
                      <label v-if="frmPedido.fileSize">{{ frmPedido.fileSize }}</label>
                    </div>
                    <span v-if="!isFilevalid.status && frmPedido.attemptSubmit" class="invalid-feedback">{{ isFilevalid.message }}</span>
                  </fieldset>
                </div>
                <div v-if="exibeEnviar" class="col-xs-12">
                  <div class="wrap-butons-line pull-right">
                    <Loader v-if="isUploading" />
                    <button v-else aria-label="Enviar" class="btn btn-primary pull-right" @click="sendDanfe">Enviar</button>
                  </div>
                </div>
              </div>
              <div v-if="mostraDownloadCliente" class="row" style="margin-top: 15px">
                <div class="col-md-6 text-right" v-show="!pedidoAnteriorIntegracaoSenior">
                  <a
                    v-bind:href="frmPedido.pdfCliente"
                    :download="`${frmPedido.chvNfeCliente}.pdf`"
                    v-on:click.stop.prevent="setupDownload(false, 'frmPedido', 'pdfCliente', 'pdf', frmPedido.chvNfeCliente)"
                  >
                    <i class="fa fa-file-pdf-o fa-2x"></i> <br />
                    Download PDF
                  </a>
                </div>
                <div class="col-md-6" v-if="frmPedido.chvNfe != ''" v-show="pedidoAnteriorIntegracaoSenior">
                  <a
                    v-bind:href="frmPedido.xmlCliente"
                    v-on:click.stop.prevent="setupDownload(true, 'frmPedido', 'xmlCliente', 'xml', frmPedido.chvNfeCliente)"
                  >
                    <i class="fa fa-file-code-o fa-2x"></i> <br />
                    Download XML
                  </a>
                </div>
              </div>

              <div class="wrap-danfe" v-if="frmPedido.chvNfe != ''">
                <div class="row">
                  <div class="col-md-12">
                    <h3 class="box-title">DOWNLOAD DANFE PDF/XML</h3>
                  </div>
                </div>
                <div class="row " v-if="frmPedido.chvNfe != ''">
                  <div class="col-md-6 " v-show="!pedidoAnteriorIntegracaoSenior">
                    <a v-bind:href="frmPedido.pdf" v-on:click.stop.prevent="setupDownload(false, 'frmPedido', 'pdf', 'pdf', frmPedido.chvNfe)">
                      <i class="fa fa-file-pdf-o fa-2x"></i> <br />
                      Download PDF
                    </a>
                  </div>
                  <div class="col-md-6" v-if="frmPedido.chvNfe != ''" v-show="pedidoAnteriorIntegracaoSenior">
                    <a v-bind:href="frmPedido.xml" v-on:click.stop.prevent="setupDownload(true, 'frmPedido', 'xml', 'xml', frmPedido.chvNfe)">
                      <i class="fa fa-file-code-o fa-2x"></i> <br />
                      Download XML
                    </a>
                  </div>
                </div>
              </div>

              <div v-if="santander.idProposta > 0">
                <div class="row">
                  <div class="col-md-12">
                    <h3 class="box-title">FORMALIZAÇÃO</h3>
                  </div>
                </div>

                <div class="row" style="width: 1187px; padding-left: 15px">
                  <div class="panel panel-primary">
                    <div class="panel-body">
                      <!-- <p>Fique por dentro de todas as vantagens que só a Aldo Crazy People pode oferecer.</p>
                    <p>Garanta o recebimento dos e-mails da Aldo clicando aqui e escolhendo a opção "sim" e fique sempre atualizado de nossas promoções, caso você não queira mais receber nossos e-mails comerciais escolha a opção "não".</p>
                    <p>Um original e exclusivo sistema de e-commerce, que integra soluções de logística, informação e promoções, garantindo mais facilidade e comodidade para os participantes da Aldo Crazy People. Disponibilizando aos clientes cadastrados, recursos que diferenciam os parceiros da empresa junto à concorrência.</p> -->
                      <h4 class="text-center">A assinatura e biometria foram coletados e a documentação foi enviada na plataforma Santander?</h4>
                      <div class="text-center">
                        <FormHelper
                          :inputVar="frmFormalizacao.formalizacao"
                          :form="frmFormalizacao"
                          :options="yesOrNoOptions()"
                          type="radio"
                          label
                        ></FormHelper>
                      </div>
                      <p class="text-center">
                        <button aria-label="Confirmar" class="btn primary-button" @click="formalizarProposta">Confirmar</button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<style scoped>
#reloadSantander:focus {
  outline: 0;
}
</style>

<script>
import 'vue-good-table/dist/vue-good-table.css'

import { VueGoodTable } from 'vue-good-table'
import Loader from './partials/Loader'
import FormHelper from './partials/FormHelper.vue'
import axios from 'axios'
import SolAgoraService from '@/services/SolAgoraService'
import DownloadDanfeService from '@/services/DownloadDanfeService'

export default {
  name: 'OrderDetail',
  components: {
    VueGoodTable,
    FormHelper,
  },
  comments: {
    Loader,
  },
  data() {
    return {
      rows: [
        {
          id: 0,
          name: 'Senior Devs',
          score: 0.15296,
          children: [
            { id: 1, name: 'John', age: 20, score: 0.03845 },
            { id: 2, name: 'Jane', age: 24, score: 0.02948 },
            { id: 3, name: 'Susan', age: 16, score: 0.08503 },
          ],
        },
        {
          id: 4,
          name: 'Junior Devs',
          score: 0.12069,
          children: [
            { id: 5, name: 'Chris', age: 55, score: 0.02946 },
            { id: 6, name: 'Dan', age: 40, score: 0.09123 },
          ],
        },
      ],
      isUploading: false,
      renderDanfe: false,
      requiredFieldMessage: 'Por favor, preencha o campo acima',
      frmPedido: {
        ID: this.$route.params.id, //query string para classificação do tipo de pedido
        tipo: this.$route.params.tipo,
        ordemCompra: '',
        dataPedido: '',
        notaFiscal: '',
        dataFaturamento: '',
        cliente: '',
        cidade: '',
        transportadora: '',
        respRetirada: '',
        situacao: '',
        tipoVenda: '',
        digitador: '',
        vendedor: '',
        comprador: '',
        rastreio: '',
        chvNfe: '',
        chvNfeCliente: '',
        xml: '/download',
        pdf: '/download',
        xmlCliente: '/download',
        pdfCliente: '/download',
        nomeArquivo: '',
        fileSize: '',
        documento64: null,
        arquivoCliente: '',
      },
      frmFormalizacao: {
        formalizacao: new this.$formInput(false, false),
      },
      santander: {
        showStatus: false,
        classAlert: '',
        token: '',
        status: '',
        dataAtualizacao: '',
        idProposta: 0,
        externalId: 0,
        numeroParcelas: null,
        valorParcelas: null,
        classBtn: 'fa fa-refresh',
      },
      solAgora: {
        showStatus: false,
        classAlert: '',
        token: '',
        status: '',
        dataAtualizacao: '',
        idProjeto: 0,
        externalId: 0,
        numeroParcelas: null,
        valorParcelas: null,
        classBtn: 'fa fa-refresh',
      },
      trackingrodonaves: {
        CTeNumber: '',
        ExpectedDeliveryDays: '',
        EmissionDate: '',
        historico: [],
      },
      trackingbraspress: {
        CTeNumber: '',
        historico: [],
      },
      columnsPesoVol: [
        { label: 'Volume', field: 'volume' },
        { label: 'Peso(KG)', field: 'peso' },
      ],
      columnsDocumentsPrazo: [
        { label: 'Documento', field: 'documento' },
        { label: 'Valor', field: 'valor' },
        { label: 'Vencimento', field: 'vencimento' },
        { label: 'Forma de Pagto.', field: 'formapagamento' },
        { label: 'N° Dias', field: 'ndias' },
        { label: 'N° Banco', field: 'nBanco' },
        { label: 'Agência', field: 'agencia' },
      ],
      columnsDocumentsVista: [
        { label: 'Documento', field: 'documento' },
        { label: 'Vencimento', field: 'vencimento' },
        { label: 'Valor', field: 'valor' },
        { label: 'N° Banco', field: 'nBanco' },
        { label: 'Banco', field: 'banco' },
      ],
      columnsProdutos: [
        { label: 'Código', field: 'codigo' },
        { label: 'Produto', field: 'produto' },
        { label: 'Unidade', field: 'unidade' },
        { label: 'Qtde', field: 'qtde' },
        { label: 'Desc. %', field: 'descPerc' },
        { label: 'IPI %', field: 'ipiPerc' },
        { label: 'ICMS %', field: 'icmsPerc' },
        { label: 'ISSQN %', field: 'issqnPerc' },
        { label: 'Red. %', field: 'redPerc' },
        { label: 'CFOP', field: 'cfop' },
        { label: 'Valor Unit.', field: 'vlUnit' },
      ],
      columnsProdutosNS: [
        { label: 'Código', field: 'codigo' },
        { label: 'Produto', field: 'produto' },
        { label: 'Qtde', field: 'qtde' },
        { label: 'Unidade', field: 'unidade' },
        { label: 'Número Série', field: 'NS' },
      ],
      columnsImpostos: [
        {
          label: 'Base Calc. Icms',
          field: 'bIcms',
          tdClass: 'align-center-td',
        },
        { label: 'Icms', field: 'icms', tdClass: 'align-center-td' },
        {
          label: 'Base Icms Subst. Trib.',
          field: 'bIcmsSub',
          tdClass: 'align-center-td',
        },
        {
          label: 'Icms Subst. Trib.',
          field: 'vlIcmsSub',
          tdClass: 'align-center-td',
        },
        { label: 'Frete', field: 'frete', tdClass: 'align-center-td' },
        { label: 'Out. Desp.', field: 'outDesp', tdClass: 'align-center-td' },
        { label: 'IPI', field: 'ipi', tdClass: 'align-center-td' },
        { label: 'Serviço', field: 'servico', tdClass: 'align-center-td' },
        { label: 'Produto', field: 'produto', tdClass: 'align-center-td' },
        { label: 'Total NF', field: 'produto', tdClass: 'align-center-td' },
      ],
      columnsDanfeCliente: [
        {
          label: 'Nota Fiscal',
          field: 'nf',
          tdClass: 'align-center-td',
          thClass: 'align-center-td',
        },
        {
          label: 'Série',
          field: 'serie',
          tdClass: 'align-center-td',
          thClass: 'align-center-td',
        },
        {
          label: 'Modelo',
          field: 'model',
          tdClass: 'align-center-td',
          thClass: 'align-center-td',
        },
        {
          label: 'Valor Total',
          field: 'valorT',
          tdClass: 'align-center-td',
          thClass: 'align-center-td',
        },
        {
          label: 'Data',
          field: 'data',
          tdClass: 'align-center-td',
          thClass: 'align-center-td',
        },
        {
          label: 'Arquivo',
          field: 'arq',
          tdClass: 'align-center-td',
          thClass: 'align-center-td',
        },
      ],
      danfeCliente: [],
      mostraUploadCliente: false,
      uploadPDF: false,
      uploadXML: false,
      mostraDownloadCliente: false,
      exibeEnviar: false,
      produtos: [],
      produtosNS: [],
      impostos: [],
      impostosDireta: [],
      pesovolume: [],
      documentosPrazo: [],
      documentosAVista: [],
      rastreio: [],
      pedidoAnteriorIntegracaoSenior: false,
    }
  },
  async mounted() {
    this.getDados()
    const self = this

    $.ajax({
      url: this.$apiUrl + 'Session.svc/getsessions',
      dataType: 'json',
      type: 'GET',
      xhrFields: { withCredentials: true },
      success: async () => {
        await self.getDadosSantander(1)
        await self.getDadosSolAgora()
      },
      error: () => {
        swal({
          title: 'É necessário estar logado',
          icon: 'warning',
        }).then(() => (location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href))
      },
    })
  },
  computed: {
    isFilevalid: function () {
      const response = {}
      response.status = false
      response.message = 'Por favor selecione um documento'

      if (this.frmPedido.nomeArquivo == null) {
        return response
      }
      response.status = true
      return response
    },

    isTypeValid: function () {
      const response = {}
      response.status = true
      response.message = 'Por favor selecione o tipo de documento'

      if (this.frmPedido.nomeArquivo == null) {
        response.status = false
        return response
      }

      return response
    },
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
  },
  methods: {
    yesOrNoOptions: function () {
      const options = [
        { code: 1, label: 'Sim', value: true },
        { code: 2, label: 'Não', value: false },
      ]

      return options
    },
    formalizarProposta() {
      axios
        .post(this.$apiUrl + 'Santander.svc/FormalizarProposta', {
          formalizar: this.frmFormalizacao.formalizacao.value,
          codigoPedido: this.$route.params.id,
        })
        .then(() => {
          if (this.frmFormalizacao.formalizacao.value) {
            swal({
              title: 'Alteração realizada com sucesso',
              text: 'A proposta foi formalizada!',
              icon: 'success',
            })
          } else {
            swal({
              title: 'Alteração realizada com sucesso',
              text: 'A proposta não está mais formalizada!',
              icon: 'success',
            })
          }
        })
        .catch(() => {
          swal({
            title: 'Erro ao tentar formalizar a proposta!',
            icon: 'error',
          })
        })
    },
    async getToken() {
      await axios
        .post(
          this.$apiUrl + 'Santander.svc/GetToken',
          {
            gravarPedido: true,
            codigoPedido: this.$route.params.id,
          },
          { withCredentials: true }
        )
        .then((response) => {
          let token = response.data.result.access_token
          this.santander.token = token
        })
    },
    async getProposta() {
      if (this.santander.idProposta == 0) {
        await axios.get(`${this.$apiUrl}Santander.svc/GetProposta/${this.$route.params.id}`).then((response) => {
          let retorno = response.data
          this.santander.token = retorno.token
          this.santander.idProposta = retorno.idProposta
        })
      }
    },

    async getStatusProposta(type) {
      await this.getToken()
      return await axios
        .post(`${this.$apiUrl}Santander.svc/GetStatusProposta`, {
          codigoPedido: this.$route.params.id,
          idProposta: this.santander.idProposta,
          token: this.santander.token,
          tipo: type,
        })
        .then((response) => {
          let error = response.data.error
          var proposta = response.data.proposal
          if (proposta != null) {
            this.santander.status = proposta.statusDescription
            this.santander.dataAtualizacao = proposta.dataAtual
            this.santander.numeroParcelas = proposta.numeroParcelas
            this.santander.valorParcelas = proposta.valorParcelas
            this.santander.externalId = proposta.proposalExternalId
            this.frmFormalizacao.formalizacao.value = response.data.formalizada
            if (proposta.status == 'E') this.santander.classAlert = 'warning'
            else if (proposta.status == 'A') this.santander.classAlert = 'success'
            return true
          } else if (error != null && error.code == 401) {
            return 401
          } else return false
        })
        .catch(() => {
          swal({
            title: 'Aviso',
            text: 'Não foi possível completar a requisição!',
            icon: 'warning',
          })

          return false
        })
    },
    async getProjetoSolAgora() {
      const res = await SolAgoraService.GetDadosProjetoSolAgora({
        apiUrl: this.$apiUrl,
        codigoPedido: this.frmPedido.ordemCompra.split('-')[0],
      })
      if (res && res.data) {
        this.solAgora.idProjeto = res.data.IdProjeto
        this.solAgora.dataAtualizacao = new Date(res.data.DataUltimaAtualizacao.match(/\d+/)[0] * 1)
        this.solAgora.numeroParcelas = res.data.Prazo
        this.solAgora.valorParcelas = res.data.VlrParcela
        this.solAgora.externalId = res.data.IdProjeto

        switch (res.data.Status) {
          case 'pending':
            this.solAgora.status = 'PENDENTE'
            this.solAgora.classAlert = 'warning'
            break

          case 'analysis':
            this.solAgora.status = 'EM ANÁLISE'
            this.solAgora.classAlert = 'warning'
            break

          case 'approved':
            this.solAgora.status = 'PROJETO APROVADO'
            this.solAgora.classAlert = 'success'
            break

          case 'denied':
            this.solAgora.status = 'PROJETO NEGADO'
            this.solAgora.classAlert = 'danger'
            break

          case 'canceled':
            this.solAgora.status = 'PROJETO CANCELADO'
            this.solAgora.classAlert = 'danger'
            break

          case 'payment_released':
            this.solAgora.status = 'LIBERADO PARA PAGAMENTO'
            this.solAgora.classAlert = 'success'
            break

          case 'paid':
            this.solAgora.status = 'PAGO'
            this.solAgora.classAlert = 'success'
            break

          case 'payment_failed':
            this.solAgora.status = 'FALHA NO PAGAMENTO'
            this.solAgora.classAlert = 'danger'
            break
        }
      }
    },
    async getDadosSantander(type) {
      this.santander.classBtn = 'fa fa-spinner fa-spin'

      await this.getProposta()
      let returnStatus = await this.getStatusProposta(type)
      if (returnStatus == 401) {
        await this.getStatusProposta(type)
      }

      this.santander.classBtn = 'fa fa-refresh'
    },
    async getDadosSolAgora() {
      this.solAgora.classBtn = 'fa fa-spinner fa-spin'

      await this.getProjetoSolAgora()

      this.solAgora.classBtn = 'fa fa-refresh'
    },
    removeClass: function () {
      this.frmPedido.nomeArquivo = ''
      this.frmPedido.fileSize = ''
      this.exibeEnviar = false
      document.getElementById('arquivoPessoal').style.display = 'none'
      document.getElementById('input-file').value = ''
    },
    sendDanfe: function () {
      const self = this
      this.isUploading = true
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.responseText != '' && xhr.responseText != null) {
            let json = JSON.parse(xhr.responseText)
            // console.log("result (enviar danfe):", json)
            if (json == '') {
              swal({
                title: 'Envio de DANFE efetuado com sucesso',
                icon: 'success',
              }).then(() => {
                this.removeClass()
                location.reload()
              })
            } else {
              swal({
                title: 'Erro no Envio da DANFE',
                text: json,
                icon: 'error',
              })
            }
          }
        }
        self.isUploading = false
      }
      xhr.open('POST', this.$apiUrl + 'UploadService.svc/uploaddropshippingnotasfiscal')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          nomeArquivo: this.string_to_slug(this.frmPedido.nomeArquivo),
          codigoCliente: this.frmPedido.cliente.split('-')[0],
          codigoPedido: this.frmPedido.ordemCompra.split('-')[0],
          bytesArquivo: this.frmPedido.documento64,
        })
      )
    },
    string_to_slug: function (value) {
      value = value.replace(/^\s+|\s+$/g, '')

      value = value.toLowerCase()

      var from = 'àáãäâèéëêìíïîòóöôùúüûñç·/_,:;'
      var to = 'aaaaaeeeeiiiioooouuuunc------'

      for (var i = 0, l = from.length; i < l; i++) {
        value = value.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      value = value.replace(/\s+/g, '-').replace(/-+/g, '-')

      return value
    },
    SelecionaArquivo: function (ev) {
      var files = ev.target.files || ev.dataTransfer.files
      if (!files.length) return

      let size = parseInt(ev.target.files[0].size / 1000)

      this.frmPedido.nomeArquivo = ev.target.files[0].name
      this.frmPedido.fileSize = size > 1000 ? 'Tamanho: ' + parseInt(size / 1000) + ' MB' : 'Tamanho: ' + size + ' KB'

      const self = this
      let base64 = ''
      const file = ev.target.files[0]
      const reader = new FileReader()
      reader.readAsDataURL(file)

      reader.onloadend = function () {
        base64 = reader.result.replace('data:' + file.type + ';base64,', '')
        self.frmPedido.documento64 = base64
        self.exibeEnviar = true
      }

      var extPermitidas = ['pdf']
      var extArquivo = this.frmPedido.nomeArquivo.toString().split('.').pop()

      if (
        typeof extPermitidas.find(function (ext) {
          return extArquivo == ext
        }) == 'undefined'
      ) {
        return false
      } else {
        return true
      }
    },
    formatCurrency: function (v) {
      //formada coluna de valores da tabela para moeda
      v = v.toString().replace(',', '.')
      var formato = {
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL',
      }
      return parseFloat(v).toLocaleString('pt-BR', formato)
    },
    getDadosImpostos: function () {
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.responseText != '' && xhr.responseText != null) {
            let element = JSON.parse(xhr.responseText)
            let item = {}
            item.bIcms = element.PevTotBaseIcms
            item.icms = element.PevTotIcms
            item.bIcmsSub = element.PevTotBaseIcmsRet
            item.vlIcmsSub = element.PevTotIcmsRet
            item.frete = element.PevTotFrete
            item.outDesp = element.PevDespesasAcessorias
            item.ipi = element.PevTotIpi
            item.servico = element.PevTotServicos
            item.produto = element.PevTotProdutos
            item.total = element.PevTotNf
            item.peso = element.PevPeso
            item.volume = element.PevVolume
            this.impostos.push(item)
            this.pesovolume.push(item)
          }
        }
      }
      xhr.open('POST', this.$apiUrl + 'PedidosVenda.svc/getimpostocliente')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          categoriaPedido: this.$route.params.tipo,
          codigoPedido: this.$route.params.id,
        })
      )
    },
    getDocumentos: function (sit) {
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200 && xhr.responseText != null) {
          if (xhr.responseText != '' && xhr.responseText != null) {
            let json = JSON.parse(xhr.responseText)
            json.forEach((element) => {
              let item = {}
              item.documento = element.Documento
              item.valor = element.Valor
              item.vencimento = element.Vencimento
              item.formapagamento = element.FormaPagamento
              item.ndias = element.NDias
              item.nBanco = element.NBanco
              item.agencia = element.Agencia
              item.notafiscal = element.NotaFiscal
              item.serie = element.Serie
              item.parcela = element.Parcela
              item.quitado = element.Quitado
              item.codBar = element.CodigoBarras
              this.documentosPrazo.push(item)
            })
          }
        } else {
          // console.log("state:", xhr.readyState, " status:", xhr.status);
        }
      }
      xhr.open('POST', this.$apiUrl + 'PedidosVenda.svc/getdocumentospedido')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(JSON.stringify({ situacao: sit, codigoPedido: this.$route.params.id }))
    },
    getDuplicata: function (tipo) {
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.responseText != '' && xhr.responseText != null) {
            let json = JSON.parse(xhr.responseText)
            json.forEach((element) => {
              let item = {}
              item.documento = element.DupDocumento
              item.valor = element.PevValornf
              item.vencimento = element.DupVencimento
              item.nBanco = element.DupBanco
              item.banco = element.DupXsdBanco
              item.baixado = element.DupBaixado
              item.codBar = element.DupBar2
              this.documentosAVista.push(item)
            })
          }
        } else {
          // console.log("state:", xhr.readyState, " status:", xhr.status);
        }
      }
      xhr.open('POST', this.$apiUrl + 'PedidosVenda.svc/getduplicata')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          tipoPedido: tipo,
          codigoPedido: this.$route.params.id,
        })
      )
    },
    getDados: function () {
      this.rastreio = []
      var self = this
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.responseText != '' && xhr.responseText != null) {
            let json = JSON.parse(xhr.responseText)
            console.log('json', json)

            const dataSai = this.parseBRDateTime(json.SaiData)
            const dataCorte = new Date(2025, 6, 1) // 1º de julho de 2025 (mês 0-indexado)
            this.pedidoAnteriorIntegracaoSenior = dataSai ? dataSai < dataCorte : false
            console.log('this.pedidoAnteriorIntegracaoSenior', this.pedidoAnteriorIntegracaoSenior)
            this.getDocumentos(json.SituacaoPedido)
            this.getDuplicata(json.PevTipoPedidoDesc)
            this.getDadosImpostos()
            this.getDadosProdutos()
            this.getDadosProdutosNumeroSerie()

            this.frmPedido.notaFiscal

            if (json.PevCodigo1Vo != '' && json.VoEcomerce == '0') {
              if (json.VoLinkDanfe != '' && json.VoLinkDanfe != null && json.VoNota != null && json.VoNota != '') {
                let danfeCliente = {}
                danfeCliente.nf = json.VoNota
                danfeCliente.serie = json.VoSerie
                danfeCliente.model = json.VoModelo
                danfeCliente.valorT = json.VoValorNfRemessa
                danfeCliente.data = json.VoData
                // console.log("arq.length")
                let arq = json.VoLinkDanfe.split('/')
                danfeCliente.arq = arq[arq.length - 1]
                this.danfeCliente.push(danfeCliente)

                this.frmPedido.arquivoCliente = json.VoLinkDanfe
                this.frmPedido.chvNfeCliente = json.chavePedidoVendaOrdem
                this.renderDanfe = true
                this.mostraDownloadCliente = true
              } else {
                this.mostraDownloadCliente = false
                if (json.UploadDanfe) {
                  this.renderDanfe = true
                  this.mostraUploadCliente = true
                  this.uploadPDF = json.UploadPDF
                  this.uploadXML = json.UploadXML
                } else {
                  this.renderDanfe = false
                  this.UploadDanfe = false
                }
              }
            } else {
              this.renderDanfe = false
              jQuery('#divdownloaddanfe').hide()
              jQuery('#botoesDanfeCliente').hide()
              jQuery('#divuploaddanfe').hide()
            }

            this.frmPedido.situacao = json.SituacaoPedido
            this.frmPedido.cidade = json.CliCidade
            this.frmPedido.ordemCompra = json.PevCodigoConcat
            this.frmPedido.dataPedido = json.PevDataPedido
            this.frmPedido.notaFiscal = json.SaiCodigo
            this.frmPedido.dataFaturamento = json.SaiData
            this.frmPedido.cliente = json.CliCodigoConcat + ' - ' + json.CliRazaoSocial
            this.frmPedido.transportadora = json.TraRazaoSocial
            this.frmPedido.respRetirada = json.PevRespRetira + ' - ' + json.PevRgRespRetira
            this.frmPedido.tipoVenda = json.PevTipoPedidoDesc
            this.frmPedido.digitador = json.UsrNomeDigitador
            this.frmPedido.vendedor = json.UsrNomeVendedor + ' - ' + json.UsrEmail
            this.frmPedido.chvNfe = json.ChvNfe

            if (json.PevComprador == null || json.PevComprador == '') {
              this.frmPedido.comprador = json.PevCompradorRevenda
            } else {
              this.frmPedido.comprador = json.PevComprador
            }

            var rast
            var link
            if (json.Rastreio == null || json.Rastreio == '') {
              rast = json.RastreioEcommerce.split(';')
            } else {
              rast = json.Rastreio.split(';')
            }

            rast.forEach((codigo) => {
              this.rastreio.push(
                "<a href='/Portais/Rastreamento/Default.aspx?codRastreamento=" + codigo + "'>Rastrear Volume: " + codigo + '</a> <br>'
              )
            })
            if (json.TraRazaoSocial.trim() === 'RODONAVES TRANSPORTES E ENCOMENDAS LTDA') {
              self.getDadosRastreioRodonaves(json.SaiCodigo)
            } else if (json.TraRazaoSocial.trim() === 'BRASPRESS TRANSPORTES URGENTES LTDA') {
              self.getDadosRastreioBraspress(json.SaiCodigo)
            }
          }
        }
      }
      xhr.open('POST', this.$apiUrl + 'PedidosVenda.svc/getdetalhespedido')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          categoriaPedido: this.$route.params.tipo,
          codigoPedido: this.$route.params.id,
        })
      )
    },
    parseBRDateTime: function (str) {
      if (!str || typeof str !== 'string') return null
      const [datePart, timePart] = str.trim().split(' ')
      if (!datePart) return null
      const [dayStr, monthStr, yearStr] = datePart.split('/')
      const day = parseInt(dayStr, 10)
      const month = parseInt(monthStr, 10)
      const year = parseInt(yearStr, 10)
      if (!day || !month || !year) return null
      let h = 0,
        m = 0,
        s = 0
      if (timePart) {
        const [hh, mm, ss] = timePart.split(':')
        h = parseInt(hh || '0', 10) || 0
        m = parseInt(mm || '0', 10) || 0
        s = parseInt(ss || '0', 10) || 0
      }
      const d = new Date(year, month - 1, day, h, m, s)
      return isNaN(d.getTime()) ? null : d
    },
    getDadosProdutos: function () {
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.response != null) {
            let json = JSON.parse(xhr.responseText)
            json.forEach((element) => {
              let item = {}
              item.codigo = element.PrdCodigoConcat
              item.produto = element.PrdDescricaoConcat
              item.unidade = element.UndSigla
              item.qtde = element.PviQtdPedido
              item.descPerc = element.PviPercDesc
              item.ipiPerc = element.PviVlrIpi
              item.icmsPerc = element.PviVlrIcmsPedido
              item.issqnPerc = element.PviIssqn
              item.redPerc = element.PviVlrReducao
              item.cfop = element.CfoCodigo2
              item.vlUnit = element.PviVlrPedido
              this.produtos.push(item)
            })
          }
        }
      }
      xhr.open('POST', this.$apiUrl + 'PedidosVenda.svc/getdetalhesproduto')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(JSON.stringify({ codigoPedido: this.$route.params.id }))
    },
    getDadosProdutosNumeroSerie: function () {
      var self = this
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.response != null) {
            let json = JSON.parse(xhr.responseText)
            json.forEach((element) => {
              let item = {}
              item.codigo = element.PrdCodigoConcat
              item.produto = element.PrdDescricaoConcat
              item.unidade = element.UndSigla
              item.qtde = element.PviQtdPedido
              item.descPerc = element.PviPercDesc
              item.ipiPerc = element.PviVlrIpi
              item.icmsPerc = element.PviVlrIcmsPedido
              item.issqnPerc = element.PviIssqn
              item.redPerc = element.PviVlrReducao
              item.NS = element.NumeroSerie
              item.cfop = element.CfoCodigo2
              item.vlUnit = element.PviVlrPedido
              let lstInsumo = []
              element.children.forEach((elementInsumo) => {
                let itemInsumo = {}
                itemInsumo.codigo = elementInsumo.PrdCodigoConcat
                itemInsumo.produto = elementInsumo.PrdDescricaoConcat
                itemInsumo.qtde = elementInsumo.PviQtdPedido
                itemInsumo.NS = elementInsumo.NumeroSerie
                itemInsumo.unidade = elementInsumo.UndSigla
                lstInsumo.push(itemInsumo)
              })
              item.children = lstInsumo
              self.produtosNS.push(item)
            })
          }
        }
      }
      xhr.open('POST', self.$apiUrl + 'PedidosVenda.svc/getdetalhesprodutonumeroserie')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(JSON.stringify({ codigoPedido: self.$route.params.id }))
    },
    getDadosRastreioRodonaves: function (nf) {
      var self = this
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.response != null) {
            let json = JSON.parse(xhr.responseText)
            self.trackingrodonaves.CTeNumber = json.CTeNumber
            json.Events.forEach((element) => {
              let itemEvent = {}
              itemEvent.Date = element.DateStr
              itemEvent.Description = element.Description
              itemEvent.HistoricId = element.HistoricId
              self.trackingrodonaves.historico.push(itemEvent)
            })
          }
        }
      }
      xhr.open('POST', this.$apiUrl + 'PedidosVenda.svc/getdetalhesrastreiorodonaves')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(JSON.stringify({ nf: nf, codigoPedido: this.$route.params.id }))
    },
    getDadosRastreioBraspress: function (nf) {
      var self = this
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.response != null) {
            let json = JSON.parse(xhr.responseText)
            if (json.conhecimentos.length > 0) {
              json.conhecimentos.forEach((element) => {
                let itemEvent = {}
                itemEvent.previsaoEntrega = element.previsaoEntrega
                itemEvent.dataEntrega = element.dataEntrega
                itemEvent.status = element.status
                itemEvent.dataOcorrencia = element.dataOcorrencia
                itemEvent.ultimaOcorrencia = element.ultimaOcorrencia
                self.trackingbraspress.historico.push(itemEvent)
              })
            }
          }
        }
      }
      xhr.open('POST', this.$apiUrl + 'PedidosVenda.svc/getdetalhesrastreiobraspress')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(JSON.stringify({ nf: nf, codigoPedido: this.$route.params.id }))
    },
    setupDownload: function (xml, obj, propriedade, extensao, chave) {
      DownloadDanfeService.SetupDownload(xml, obj, propriedade, extensao, chave, this, true)
    },
  },
}
</script>
